var map = {
	"./blue.scss": [
		"ffb5",
		"chunk-774dafb6"
	],
	"./dark.scss": [
		"1d9c",
		"chunk-746154ec"
	],
	"./light.scss": [
		"d500",
		"chunk-771a7e38"
	],
	"./orange.scss": [
		"3b68",
		"chunk-747c8ab8"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "903d";
module.exports = webpackAsyncContext;